import * as React from "react";
import styled from "styled-components";
import { Widget } from "../../../../../components/widget";

interface ISubmittedFormProps {}

const Container = styled(Widget)`
  background: #ddd;
  color: #000;
  display: flex;
  justify-content: center;
`;

const SubmittedForm: React.FunctionComponent<ISubmittedFormProps> = (props) => {
  return (
    <Container>
      <h2 className="h1">This form has been already submitted</h2>
    </Container>
  );
};

export default SubmittedForm;
